import { render, staticRenderFns } from "./FoldersABM.vue?vue&type=template&id=21c8f6f0&scoped=true&"
import script from "./FoldersABM.vue?vue&type=script&lang=js&"
export * from "./FoldersABM.vue?vue&type=script&lang=js&"
import style0 from "./FoldersABM.vue?vue&type=style&index=0&id=21c8f6f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c8f6f0",
  null
  
)

export default component.exports